export default __webpack_public_path__ + "static/_1Png-0bcc302dd62f473acaef7e4b11ec1c07.png";